import type { RegularButton } from '@pkg/sanity-utils/types/button';
import { convertGeneralLinkToLinkType } from './generalLinkToLink';

export const buttonToLink = (button: RegularButton) => {
  return convertGeneralLinkToLinkType(button.link, button.title, button._key);
};
